import _set from 'lodash/set';

import { MutationTree } from "vuex";
import { CustomersState } from "./types";
import { Customer } from "@/models";
import _ from 'lodash';

/**
 * Mutations
 *
 * The only way to actually change state in a Vuex store is by committing a mutation.
 * - Vuex mutations are very similar to events: each mutation has a string type and a handler.
 * - The handler function is where we perform actual state modifications - it receives the state as the first argument:
 * - You cannot directly call a mutation handler.
 * - Think of it more like event registration: "When a mutation with type X is triggered, call this handler."
 * - To invoke a mutation handler, you need to call store.commit with its type e.g. `store.commit('setUser', user)`
 */
 export const mutations: MutationTree<CustomersState> = {

	/**
	 * Set the customers list
	 * 
	 * @param {CustomersState} state
	 * @param {Customer[]} Customers
	 * @returns void
	 */
	 setCustomers(state: CustomersState, customers: Customer[]): void {
		state.list = customers;
	},

	/**
	 * Set current customer
	 * 
	 * @param {CustomersState} state
	 * @param {Customer} Customer
	 * @returns void
	 */
	 setCurrent(state: CustomersState, customer: Customer): void {
		state.current = customer;
	},

	/**
	 * Set the currently edited/viewed customer
	 */
	 setCustomerDeep(state: CustomersState, payload: {path: string, data: any}): void {
    state.current = Object.assign(new Customer, _set(state.current, payload.path, payload.data));
  },

	/**
	 * ++ Unsaved changes
	 * 
	 * @param state CustomersState
	 * @param element string
	 * @returns void
	 */
	 addUnsavedChange(state: CustomersState, element: string): void {
		state.updates = [...new Set(state.updates.concat([element]))];
	},

	/**
 	* Reset Unsaved changes
 	* 
 	* @param state CustomersState
 	* @returns void
 	*/
	 resetUnsavedChanges(state: CustomersState): void {
		state.updates = [];
	},

	resetState(state: CustomersState): void {
		state.current = new Customer;
		state.list = [];
		state.updates = [];
	},

	rehydrateState(state: CustomersState): void {
    state.current = new Customer(state.current);
		state.list = state.list.map((x: any) => new Customer(x));
  }

 }
